module.exports = __webpack_public_path__ + "media/images/sprites/jsgrid-icons-e877cee58135cfe743e35170bd71ab59.png";